































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import notificationService from '@/services/notificationService';
import Card from '@/components/default/Card.vue';
import projectsRepository from '../../services/projectsRepository';

@Component({
  components: {
    Card,
  },
  computed: {
    ...mapGetters('projects', {
      status: 'getStatusName',
    }),
  },
})
export default class ProjectDetails extends Vue {
  @Prop({ required: false })
  public value?: any;

  async findLocation() {
    const self = this;
    if (navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition(this.setLocation);
    }
  }

  async duplicate() {
    try {
      if (confirm('Bent u zeker dat u een kopie wilt maken van dit project?')) {
        const copyProjectResult = await projectsRepository.duplicateProject(this.value.id);
        this.$router.push({ path: `/projects/${copyProjectResult.data.id}` });
      }
    } catch (err) {
      notificationService.showAxiosError(err);
    }
  }

  async setLocation(position: Position) {
    if (!this.value.location) {
      this.value.location = {};
    }
    this.value.location.latitude = position.coords.latitude;
    this.value.location.longitude = position.coords.longitude;
    this.value.location.accuracy = position.coords.accuracy;

    this.$emit('updated');
  }
  showEditDialog() {
    this.$emit('edit');
  }
}
